import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/caller';

interface UseTourPackageDetailParams {
  tourId?: number;
  tourPackageId: number;
  tourPackageDetailId?: number;
  salesDate?: string;
  checkInDate?: string;
  enabled?: boolean;
}

export const useTourPackageDetail = ({
  tourId,
  tourPackageId,
  tourPackageDetailId,
  salesDate,
  checkInDate,
  enabled = true,
}: UseTourPackageDetailParams) => {
  return useQuery(
    [
      'tourPackageDetail',
      tourId,
      tourPackageId,
      tourPackageDetailId,
      salesDate,
      checkInDate,
    ],
    async () => {
      return callService('ToursService', 'tourPackageDetail', {
        tourPackageId,
        tourPackageDetailId,
        salesDate,
        checkInDate,
      });
    },
    {
      enabled: enabled && !!tourPackageId,
      refetchOnMount: 'always',
      staleTime: 0,
      cacheTime: 0,
    }
  );
};
